<script setup>
import { ref } from "vue";
import SaveButtons from '../commons/SaveButtons.vue';
import CustomInput from '../commons/CustomInput.vue';
import ReferenceCard from '../commons/ReferenceCard.vue';
import UnselectedIndicator from '../commons/UnselectedIndicator.vue';
import CustomLoading from '../commons/CustomLoading.vue';
import BottomActions from '../commons/BottomActions.vue';
import ModalProps from '../commons/ModalProps.vue';
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
import axios from 'axios';
import { urlMainAPI, defaultSuccess, showError } from "@/global";
</script>
<template>
    <section>
        <CustomLoading v-if="this.isReloading" msg="Armazenando Informações" />
        <UnselectedIndicator v-if="!isCreating && !selectedIndicator.id" />
        <section v-else>
            <section class="refs-container">
                <b-tabs class="refs-forms" align="start" lazy no-nav-style @activate-tab="handleActive"
                    v-model="tabIndex">
                    <b-tab :title="$t('coletor')" active class="ref-tab">
                        <section class="ref-content">
                            <section class="col-inputs">
                                <CustomInput id="colectorName" type="text" :title="$t('nome-do-coletor') + '*'"
                                    :modelRef="this.creatingReference.colName" :inputFunc="event => {
                                        this.creatingReference.colName = event.target.value
                                        this.creatingReference.label = event.target.value
                                    }" :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                <CustomInput id="colectorBase" type="select"
                                    :title="$t('selecione-a-base-de-coleta') + '*'"
                                    :modelRef="this.creatingReference.collectorBase"
                                    :inputFunc="event => changeCollectorBase(event.target.value)"
                                    :optList="MediatorIndicatorEditor.collectorsFound" optValue="name" optDisplay="name"
                                    :useIdx="false" />

                                <!-- Automação Online -->
                                <template v-if="this.collectType == 'autom'">
                                    <CustomInput id="automTypeSelected" type="select" :title="$t('origin') + '*'"
                                        :modelRef="this.automType.toUpperCase()" :inputFunc="event => {
                                            this.automType = event.target.value.toLowerCase()
                                            this.creatingReference.colType = event.target.value.toLowerCase()
                                        }" :optList="MediatorIndicatorEditor.automTypes" optValue="name"
                                        optDisplay="name" :useIdx="false" />

                                    <template v-if="this.automType == 'opc'">
                                        <CustomInput id="tagname" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.tagname"
                                            :inputFunc="event => this.creatingReference.tagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                        <CustomInput id="opctagname" type="text" :title="$t('opctagname') + '*'"
                                            :modelRef="this.creatingReference.opctagname"
                                            :inputFunc="event => this.creatingReference.opctagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                        <CustomInput id="host"
                                            :type="MediatorIndicatorEditor.uniqueHosts.length > 0 ? 'select' : 'text'"
                                            :title="$t('host') + '*'" :modelRef="this.creatingReference.host"
                                            :inputFunc="event => this.creatingReference.host = event.target.value"
                                            :optList="MediatorIndicatorEditor.uniqueHosts" optValue="name"
                                            optDisplay="name" :useIdx="false" />
                                        <CustomInput id="opcserver"
                                            :type="MediatorIndicatorEditor.uniqueServers.length > 0 ? 'select' : 'text'"
                                            :title="$t('opcserver') + '*'" :modelRef="this.creatingReference.opcserver"
                                            :inputFunc="event => this.creatingReference.opcserver = event.target.value"
                                            :optList="MediatorIndicatorEditor.uniqueServers" optValue="name"
                                            optDisplay="name" :useIdx="false" />
                                    </template>

                                    <template v-if="this.automType == 'intelup'">
                                        <CustomInput id="tagnameint" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.tagname"
                                            :inputFunc="event => this.creatingReference.tagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="inteluptagname" type="text" :title="$t('inteluptagname') + '*'"
                                            :modelRef="this.creatingReference.inteluptagname"
                                            :inputFunc="event => this.creatingReference.inteluptagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                    </template>

                                    <template v-if="this.automType == 'pisystem'">
                                        <CustomInput id="tagnameint" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.tagname"
                                            :inputFunc="event => this.creatingReference.tagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="pitagname" type="text" :title="$t('pitagname') + '*'"
                                            :modelRef="this.creatingReference.pitagname"
                                            :inputFunc="event => this.creatingReference.pitagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="filter" type="select" :title="$t('filter')"
                                            :modelRef="this.creatingReference.filter"
                                            :inputFunc="event => this.creatingReference.filter = event.target.value.toString()"
                                            :optList="[{ name: 'Não' }, { name: 'Sim' }]" optValue="name"
                                            optDisplay="name" :useIdx="true" />
                                    </template>

                                    <template v-if="this.automType == 'webservice'">
                                        <CustomInput id="tagname" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.tagname"
                                            :inputFunc="event => this.creatingReference.tagname = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="description" type="text" :title="$t('description') + '*'"
                                            :modelRef="this.creatingReference.description"
                                            :inputFunc="event => this.creatingReference.description = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="webservice" type="text" :title="$t('webservice') + '*'"
                                            :modelRef="this.creatingReference.webserviceName"
                                            :inputFunc="event => this.creatingReference.webserviceName = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="corporation" type="text" :title="$t('codigo-unidade') + '*'"
                                            :modelRef="this.creatingReference.corporation"
                                            :inputFunc="event => this.creatingReference.corporation = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="equipment" type="text" :title="$t('equipmentTitle')"
                                            :modelRef="this.creatingReference.equipment"
                                            :inputFunc="event => this.creatingReference.equipment = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="material" type="text" :title="$t('material')"
                                            :modelRef="this.creatingReference.material"
                                            :inputFunc="event => this.creatingReference.material = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="property" type="text" :title="$t('property') + '*'"
                                            :modelRef="this.creatingReference.property"
                                            :inputFunc="event => this.creatingReference.property = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="indId" type="text" :title="$t('indicator-id') + '*'"
                                            :modelRef="this.creatingReference.indicator"
                                            :inputFunc="event => this.creatingReference.indicator = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="acumulate" type="select" :title="$t('acumulado') + '*'"
                                            :modelRef="this.creatingReference.acumulate"
                                            :inputFunc="event => this.creatingReference.acumulate = event.target.value.toString()"
                                            :optList="[{ name: 'Não' }, { name: 'Sim' }]" optValue="name"
                                            optDisplay="name" :useIdx="true" />

                                        <CustomInput id="media" type="select" :title="$t('media') + '*'"
                                            :modelRef="this.creatingReference.average"
                                            :inputFunc="event => this.creatingReference.average = event.target.value.toString()"
                                            :optList="[{ name: 'Não' }, { name: 'Sim' }]" optValue="name"
                                            optDisplay="name" :useIdx="true" />

                                    </template>
                                </template>

                                <template v-if="this.collectType == 'analytic'">
                                    <CustomInput id="analyticType" type="select" :title="$t('origin') + '*'"
                                        :modelRef="this.analyticType.toUpperCase()" :inputFunc="event => {
                                            this.analyticType = event.target.value.toLowerCase()
                                            this.creatingReference.colType = event.target.value.toLowerCase()
                                        }" :optList="MediatorIndicatorEditor.analyticsTypes" optValue="name"
                                        optDisplay="name" :useIdx="false" />

                                    <template v-if="this.analyticType == 'sap'">
                                        <CustomInput id="materialFeature" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.materialFeature"
                                            :inputFunc="event => this.creatingReference.materialFeature = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />

                                        <CustomInput id="center" type="number" :title="$t('codigo-unidade') + '*'"
                                            :modelRef="this.creatingReference.center"
                                            :inputFunc="event => this.creatingReference.center = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" min="true" />
                                    </template>

                                    <template v-if="this.analyticType == 'gatec'">
                                        <CustomInput id="cod_variavel" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.cod_variavel"
                                            :inputFunc="event => this.creatingReference.cod_variavel = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                    </template>

                                    <template v-if="this.analyticType == 'pims'">
                                        <CustomInput id="Var_Codigo" type="text" :title="$t('tag-name') + '*'"
                                            :modelRef="this.creatingReference.Var_Codigo"
                                            :inputFunc="event => this.creatingReference.Var_Codigo = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                        <CustomInput id="emp_codemp" type="number" :title="$t('codigo-unidade') + '*'"
                                            :modelRef="this.creatingReference.emp_codemp"
                                            :inputFunc="event => this.creatingReference.emp_codemp = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" min="true" />
                                        <CustomInput v-if="this.sufix == true" id="sufix" type="number"
                                            :title="$t('sufix') + '*'" :modelRef="this.creatingReference.SUF_CODIGO"
                                            :inputFunc="event => this.creatingReference.SUF_CODIGO = event.target.value"
                                            :optList="[]" optValue="" optDisplay="" :useIdx="false" min="true" />
                                    </template>


                                </template>

                            </section>
                            <section class="cols-saturation">
                                <span>{{ this.$t('saturation') }}</span>
                                <section>
                                    <CustomInput id="minSaturation" type="number" :title="$t('minimo-value') + '*'"
                                        :modelRef="this.creatingReference.minSaturation"
                                        :inputFunc="event => this.creatingReference.minSaturation = event.target.value"
                                        :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                    <CustomInput id="maxSaturation" type="number" :title="$t('maximo-value') + '*'"
                                        :modelRef="this.creatingReference.maxSaturation"
                                        :inputFunc="event => this.creatingReference.maxSaturation = event.target.value"
                                        :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                                </section>
                            </section>
                        </section>

                    </b-tab>
                    <b-tab :title="$t('fixedValue')" class="ref-tab">
                        <section class="ref-content">
                            <CustomInput id="fixedName" type="text" :title="$t('nome-da-constante') + '*'"
                                :modelRef="this.creatingReference.fixedName" :inputFunc="event => {
                                    this.creatingReference.fixedName = event.target.value
                                    this.creatingReference.label = event.target.value
                                }" :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                            <CustomInput id="fixedValue" type="number" :title="$t('valor-da-constante') + '*'"
                                :modelRef="this.creatingReference.value"
                                :inputFunc="event => this.creatingReference.value = event.target.value" :optList="[]"
                                optValue="" optDisplay="" :useIdx="false" />
                        </section>
                    </b-tab>
                    <b-tab :title="$t('outOfSpecificationTableIndicator')" class="ref-tab">
                        <section class="ref-content">
                            <CustomInput id="indToSeach" type="text" :title="$t('indicator-filter')"
                                :modelRef="filterIndicator"
                                :inputFunc="event => this.filterIndicator = event.target.value" :optList="[]"
                                optValue="" optDisplay="" :useIdx="false" />

                            <section class="ind-list-ref">
                                <section v-for="(ind, idx) in this.searchIndicator()"
                                    :key="`ind-${ind.indicatorId}-${idx}`" class="ind-ref">
                                    <p :title="ind.indicatorName">{{ ind.indicatorName }}</p>
                                    <section class="addIndBtns">
                                        <section class="addReal" @click="addIndToReference(ind, 'real')">
                                            <span>Real</span>
                                            <b-icon-plus-circle-fill />
                                        </section>
                                        <section class="addPrev" @click="addIndToReference(ind, 'prev')">
                                            <span>Previsto</span>
                                            <b-icon-plus-circle-fill />
                                        </section>
                                    </section>
                                </section>
                            </section>
                        </section>
                    </b-tab>
                    <BottomActions :leftFunc="clearRefTabs" :rightFunc="createNewReference" leftLabel="Limpar"
                        :rightLabel="addLabel" rightIcon="add" />

                    <section class="tagListBtn" v-if="MediatorIndicatorEditor.allowedTags.length > 0">
                        <p @click="() => this.$bvModal.show('tagsAllowedList')">Consultar Tags</p>
                    </section>
                </b-tabs>
                <section class="reference-created">
                    <p>Referências Criadas</p>
                    <section class="refs-list">
                        <section v-for="(refC, idx) in this.createdReferences" :key="`${refC}-${idx}`"
                            class="referenceItem" :title="refC.label">
                            <span draggable="true" @dragstart="refDrag($event, refC)">{{ refC.label }}</span>
                            <section>
                                <b-icon-trash-fill title="Remover Referência"
                                    @click="() => openRemoveModal(refC)"></b-icon-trash-fill>
                                <b-icon-pencil-fill title="Editar Referência"
                                    @click="() => selectReference(refC)"></b-icon-pencil-fill>
                                <b-icon-plus-circle-fill title="Adicionar ao Fim da Equação"
                                    @click="() => addToEquation(refC, 'reference')"></b-icon-plus-circle-fill>
                            </section>
                        </section>

                    </section>
                </section>
                <section class="real-equation">
                    <p>Equação Real</p>
                    <section class="operations">
                        <section v-for="(item, itemIdx) in this.operationsAllowed" :key="`${item.group}-${itemIdx}`"
                            :class="`op-container ${item.group}`">
                            <p>{{ item.groupName }}</p>
                            <section>
                                <ReferenceCard v-for="(op, idx) in item.ops" :key="`${op.label}-${idx}`" :reference="op"
                                    cardType="operation" deleteClass="" :title="op.tooltip"
                                    @click.native="handleOperation(item.group, op)" :customClass="item.group"
                                    :draggable="item.group != 'funcs'" @dragstart.native="refDrag($event, op)" />
                            </section>
                        </section>
                    </section>
                    <section class="equation">
                        <ReferenceCard v-for="(ref, idx) in this.equationList" :key="`${ref}-${idx}`"
                            :id="`${ref.label}-${idx}-equation`" :reference="ref" :cardType="ref.type"
                            deleteClass="deleteClass" customClass="" @click.native="() => deleteInEquation(ref, idx)"
                            :enterFunc="() => refEnter(ref, idx)" :leaveFunc="() => refLeave(ref, idx)"
                            :dropFunc="(evt) => refDrop(evt, ref, idx)" />
                    </section>
                    <BottomActions :leftFunc="clearEquation" :rightFunc="undoEquation" leftLabel="Limpar"
                        rightLabel="Desfazer" rightIcon="undo" />
                    <section v-if="this.validExp.status == false" class="validation">
                        <b-icon-exclamation-circle-fill></b-icon-exclamation-circle-fill>
                        <span>{{ this.validExp.msg }}</span>
                    </section>
                </section>
            </section>
            <SaveButtons :isCreating="isCreating" :allowTab="allowTab" tabToEnable="calculated"
                nextTabName="Referência Prevista" :enableCommit="enableSave" :saveFunc="applyCollectedReferences"
                :clearFunc="clearChanges" :creationToKeep="isCreating ? toSaveOnLocal : {}" />
        </section>

        <b-modal id="funcModal" :title="modalOp.fullName" hide-footer>
            <ModalProps :modalType="modalOp.label" :addFunc="addFuncFormatToEquation"
                :references="this.createdReferences" :hasCondition="modalOp.hasCondit"
                :needWeight="modalOp.hasWeight" />
        </b-modal>

        <b-modal id="removeReferenceModal" title="Remover Referência" ok-variant=danger :ok-title="$t('yes')"
            :cancel-title="$t('no')" @cancel="$bvModal.hide('removeReferenceModal')" @ok="removeReference">
            <p>Deseja <strong>remover</strong> a referência <strong>{{ this.removingReference.label }}</strong>?
                Lembrando que
                essa ação também removerá a referência da equação.</p>
        </b-modal>

        <b-modal size="xl" id="tagsAllowedList" title="Lista de Tags" hide-footer>
            <input type="text" v-model="tagAllowedSearch" id="filterAllowedTags" ref="allowedTagsSearch"
                placeholder="Filtrar tags">
                <span class="colTabledouble">Clique 2x para preencher os campos do coletor.</span>
            <section class="allow-tag-list">
                <b-table sticky-header striped hover :items="this.filterAllowTagList()" :fields="[
                    {
                        key: 'tagname',
                        label: 'Nome da Tag'
                    },
                    {
                        key: 'coltagname',
                        label: 'Tag do Coletor'
                    },
                    {
                        key: 'host',
                        label: 'Host (IP)'
                    },
                    {
                        key: 'serverName',
                        label: 'Nome do Servidor'
                    },
                ]" @row-dblclicked="selectTagsFromTable" class="colTagsTable">
            </b-table>
            </section>
        </b-modal>

    </section>
</template>
<script>
export default {
    name: 'CollectedReference',
    components: { SaveButtons, ReferenceCard, CustomInput, UnselectedIndicator, BottomActions, ModalProps, CustomLoading },
    props: {
        isCreating: Boolean,
        allowTab: Function,
        selectedIndicator: Object,
        reloadIndicator: Function
    },

    data() {
        return {
            loading: false,
            enableSave: false,
            isReloading: false,
            addLabel: "Adicionar",
            toSaveOnLocal: { type: 'collected' },
            tabIndex: 0,
            operationsAllowed: MediatorIndicatorEditor.operationsAllowed,
            createdReferences: [],
            equationList: [],
            originalcreatedReferences: [],
            originalequationList: [],
            collectorBasesAllowed: [],
            removingReference: {},
            modalOp: {},
            creatingReference: {},
            referenceType: 'collector',
            collectType: '',
            automType: '',
            analyticType: '',
            edited: false,
            sufix: false,
            filterIndicator: '',
            validExp: { status: true, msg: '' },
            uniqueHosts: [],
            uniqueServers: [],
            tagAllowedSearch: ref(""),
        }
    },

    watch: {
        "equationList"() {
            let labelEquation = this.equationList.map(item => item.label);
            this.validExp = MediatorIndicatorEditor.validateEquation(labelEquation);

            if (this.validExp.status == true) {
                this.enableSave = true;
            }
        },

        "selectedIndicator"(ind) {

            if (ind.realRefs && ind.realRefs.createdReferences && ind.realRefs.equation) {
                if (this.createdReferences && this.createdReferences != undefined) {
                    this.createdReferences = [...ind.realRefs.createdReferences];
                    this.originalcreatedReferences = [...this.createdReferences];
                }

                if (this.equationList && this.equationList != undefined) {
                    this.equationList = [...ind.realRefs.equation];
                    this.originalequationList = [...this.equationList];
                }
            }

            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
            this.addLabel = "Adicionar";

        }
    },

    methods: {
        searchIndicator() {
            return this.filterIndicator != '' && this.filterIndicator != undefined ? MediatorIndicatorEditor.indicatorsList.filter(item => item.indicatorName.toLowerCase().includes(this.filterIndicator.toLowerCase())) : MediatorIndicatorEditor.indicatorsList;
        },

        filterAllowTagList() {
            return this.tagAllowedSearch != '' && this.tagAllowedSearch != undefined ? MediatorIndicatorEditor.allowedTags.filter(item => item.tagname.toLowerCase().includes(this.tagAllowedSearch.toLowerCase()) || item.coltagname.toLowerCase().includes(this.tagAllowedSearch.toLowerCase())) : MediatorIndicatorEditor.allowedTags;
        },

        selectTagsFromTable(item) {
            if(this.collectType == "autom" && this.creatingReference.colType != '' && this.automType != ''){
                let objKeys = {
                    tagname: item.tagname.toString()
                }

                if(this.creatingReference.colType == "opc"){
                    objKeys.host = item.host.toString();
                    objKeys.opcserver = item.serverName.toString();
                    objKeys.opctagname = item.coltagname.toString();
                }else if(this.creatingReference.colType == "intelup"){
                    objKeys.inteluptagname = item.coltagname.toString();
                }else if(this.creatingReference.colType == "pisystem"){
                    objKeys.pitagname = item.coltagname.toString();
                }
                
                this.creatingReference = {...this.creatingReference, ...objKeys};
                defaultSuccess(this.$t('collector-selected'))
            }
        },

        addToEquation(item, type) {
            if (item.type == 'collector') {
                item.desc = `Coletor\nNome da Tag: ${item.tagname}`
                if (item.colType == 'opc') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.tagname}\nTag OPC: ${item.opctagname}`
                } else if (item.colType == 'intelup') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.tagname}\nTag OPC: ${item.inteluptagname}`
                } else if (item.colType == 'pisystem') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.tagname}\nTag OPC: ${item.pitagname}`
                } else if (item.colType == 'webservice') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.tagname}`
                } else if (item.colType == 'sap') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.materialFeature}\nCód. Unidade: ${item.center}`
                } else if (item.colType == 'gatec') {
                    item.desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.cod_variavel}`
                } else if (item.colType == 'pims') {
                    let desc = `Coletor\nTipo de Coleta: ${item.colType.toUpperCase()}\nNome da Tag: ${item.Var_Codigo}\nCód. Unidade: ${item.emp_codemp}`
                    item.desc = desc
                }
            }

            this.equationList.push({ label: item.label, type: type, structure: item });

            if (type == 'operation' && item.isFunc == true) this.equationList.push({ label: '(', type: 'operation', structure: { label: '(', isFunc: false, colorClass: '', tooltip: `Abrir Parêntese:\nExemplo:\n(valor_01 ...` } });

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        addIndToReference(ind, type) {
            let indOriginObj = { ...ind }
            let indObj = {};

            if (type == 'real') {
                indOriginObj.type = "external";
                indObj = { label: ind.valueEquation, type: 'reference', structure: indOriginObj }
                indObj.structure.desc = `Indicador Externo\nNome do Indicador: ${ind.indicatorName}\nEquação Real: ${ind.valueEquation}`
            } else if (type == 'prev') {
                if (ind.targetEquation && ind.targetEquation == "REFERENCE" && ind.refValue) {
                    indOriginObj.type = "fixed";
                    indOriginObj.value = ind.refValue;
                } else {
                    indOriginObj.type = "external";
                }

                indObj = { label: ind.targetEquation, type: 'reference', structure: indOriginObj }
                indObj.structure.desc = `Indicador Externo\nNome do Indicador: ${ind.indicatorName}\nEquação Prevista: ${ind.targetEquation}`
            }

            this.equationList.push(indObj);

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        deleteInEquation(ref, idx) {
            let refInEq = this.equationList[idx];

            if (refInEq != undefined && refInEq.label == ref.label) {
                this.equationList.splice(idx, 1)
            }

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        addFuncFormatToEquation(eqArr) {
            this.equationList.push(...eqArr);
            this.$bvModal.hide('funcModal')
            this.modalOp = {};

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        openRemoveModal(ref) {
            this.removingReference = { ...ref }
            this.$bvModal.show('removeReferenceModal');
        },

        removeReference() {
            this.createdReferences = this.createdReferences.filter(item => item.id != this.removingReference.id);

            this.equationList = this.equationList.filter(item =>
                item.type != "reference" || (item.type == "reference" && item.structure.id != this.removingReference.id)
            )

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        selectReference(ref) {
            this.creatingReference = {};

            if (ref.type == "collector") {
                this.tabIndex = 0;
            }
            else if (ref.type == "fixed") {
                this.tabIndex = 1;
            }
            else if (ref.type == "indicator") {
                this.tabIndex = 2;
            }

            if (ref.collectorBase) {
                let colBase = ref.collectorBase.toLowerCase();
                if ((colBase.includes('automacao') || colBase.includes('automação'))) {
                    this.collectType = 'autom';
                    this.automType = ref.colType ? ref.colType : '';
                } else if (colBase.includes('analitico') || colBase.includes('analítico') || colBase.includes('sap') || colBase.includes('pims') || colBase.includes('gatec')) {
                    this.collectType = 'analytic'
                    this.analyticType = ref.colType ? ref.colType : '';

                    if (colBase.includes('sufixo') || colBase.includes('com sufixo') || colBase.includes('c/ sufixo') || colBase.includes('com sufíxo') || colBase.includes('c/ sufíxo') || colBase.includes('c/sufixo') || colBase.includes('c/sufíxo')) {
                        this.sufix = true
                    } else {
                        this.sufix = false
                    }
                }
            }

            if (ref.type == "collector" && !ref.colType) MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Origem do coletor não encontrada!', 'As informações do coletor não foram encontradas, não será possível editá-lo.')

            this.creatingReference = { ...ref };
            this.addLabel = "Atualizar";
        },

        createNewReference() {
            let validateFields = true;
            console.log("REF: ", this.creatingReference)

            if (this.referenceType == 'collector') {
                if (!this.collectType || this.collectType == '') {
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Base de Coleta Vazia.', 'Selecione a base de coleta.');
                    return;
                }

                if (this.collectType == 'autom' && (!this.automType || this.automType == '')) {
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Tipo de Coleta Vazio.', 'Selecione o tipo de coleta.');
                    return;
                }

                if (this.collectType == 'analytic' && (!this.analyticType || this.analyticType == '')) {
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Tipo de Coleta Vazio.', 'Selecione o tipo de coleta.');
                    return;
                }

                if (this.automType.toLowerCase() == 'opc') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'tagname', 'opctagname', 'host', 'opcserver', 'minSaturation', 'maxSaturation'], ['', undefined]);
                    if (validateFields == true) {
                        let validateTag = MediatorIndicatorEditor.checkOPCTags(this.creatingReference.tagname, this.creatingReference.opctagname);

                        if (validateTag == false) {
                            MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Tag Já Cadastrada', 'O nome da TAG já existe no banco de coleta, em outra TAG OPC. Por favor, verifique a lista de tags.');
                            return;
                        }
                    }

                } else if (this.automType.toLowerCase() == 'intelup') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'minSaturation', 'maxSaturation', 'inteluptagname', 'tagname'], ['', undefined]);
                }
                else if (this.automType.toLowerCase() == 'pisystem') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'minSaturation', 'maxSaturation', 'tagname', 'pitagname', 'filter'], ['', undefined]);
                }
                else if (this.automType.toLowerCase() == 'webservice') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'minSaturation', 'maxSaturation', 'tagname', 'description', 'webserviceName', 'corporation', 'property', 'indicator', 'acumulate', 'average'], ['', undefined]);
                }
                else if (this.analyticType.toLowerCase() == 'sap') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'minSaturation', 'maxSaturation', 'materialFeature', 'center'], ['', undefined]);
                }
                else if (this.analyticType.toLowerCase() == 'gatec') {
                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['colName', 'collectorBase', 'cod_variavel', 'maxSaturation', 'minSaturation',], ['', undefined]);
                }
                else if (this.analyticType.toLowerCase() == 'pims') {
                    let fieldsArr = ['colName', 'collectorBase', 'minSaturation', 'maxSaturation', 'Var_Codigo', 'emp_codemp']

                    if (this.sufix == true) {
                        fieldsArr.push('SUF_CODIGO')
                    }

                    validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, fieldsArr, ['', undefined]);
                }
            } else if (this.referenceType == 'fixed') {
                validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['fixedName', 'value'], ['', undefined]);
            }

            if (Object.keys(this.creatingReference).length == 0 || Object.values(this.creatingReference).length == 0 || validateFields == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos obrigatórios da referência.');
                return;
            }

            if (this.addLabel == "Atualizar") {
                this.edited = true;

                this.createdReferences = this.createdReferences.map(item => {
                    if (item.id == this.creatingReference.id) {
                        return { ...this.creatingReference };
                    } else return item;
                });

                this.equationList.forEach(item => {
                    if (item.type == 'reference' && item.structure.id == this.creatingReference.id) {
                        item.structure = {}
                        item.structure = { ...this.creatingReference }
                        item.label = this.creatingReference.label;

                        if (item.structure.type == 'fixed') {
                            this.creatingReference.desc = `Valor Fixo\nValor: ${this.creatingReference.value}`
                            item.structure.desc = `Valor Fixo\nValor: ${this.creatingReference.value}`
                        } else if (item.structure.type == 'collector') {
                            item.structure.desc = `Coletor\nNome da Tag: ${this.creatingReference.tagname}`
                            this.creatingReference.desc = `Coletor\nNome da Tag: ${this.creatingReference.tagname}`
                            this.creatingReference.colType = this.collectType == 'autom' ? this.automType : this.analyticType;
                            if (item.structure.colType == 'opc') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.opctagname}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.opctagname}`
                            } else if (item.structure.colType == 'intelup') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.inteluptagname}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.inteluptagname}`
                            } else if (item.structure.colType == 'webservice') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}`
                            } else if (item.structure.colType == 'pisystem') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.pitagname}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.tagname}\nTag OPC: ${this.creatingReference.pitagname}`
                            } else if (item.structure.colType == 'sap') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.materialFeature}\nCód. Unidade: ${this.creatingReference.center}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.materialFeature}\nCód. Unidade: ${this.creatingReference.center}`
                            } else if (item.structure.colType == 'gatec') {
                                item.structure.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.cod_variavel}`
                                this.creatingReference.desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.cod_variavel}`
                            } else if (item.structure.colType == 'pims') {
                                let desc = `Coletor\nTipo de Coleta: ${this.creatingReference.colType.toUpperCase()}\nNome da Tag: ${this.creatingReference.Var_Codigo}\nCód. Unidade: ${this.creatingReference.emp_codemp}`

                                if (this.creatingReference.SUF_CODIGO != '') desc += `\nSufixo: ${this.creatingReference.SUF_CODIGO}`

                                item.structure.desc = desc
                                this.creatingReference.desc = desc
                            }

                        }
                    }
                });

                this.edited = true;
                this.addLabel = "Adicionar";
                this.creatingReference = {}
                this.enableSave = true;
                this.collectType = '';
                this.automType = '';

                if (this.isCreating) {
                    this.updateStorage()
                }

                return;
            }

            let newRef = {
                ...this.creatingReference,
                type: this.referenceType,
                colType: this.collectType == 'autom' ? this.automType : this.analyticType,
                id: `${this.createdReferences.length}-${this.referenceType}-${this.creatingReference.label}`
            }

            this.createdReferences.push(newRef);
            this.creatingReference = {}
            this.collectType = '';
            this.automType = '';
            this.analyticType = '';

            if (this.isCreating) {
                this.updateStorage()
            }

            this.addLabel = "Adicionar";
            this.enableSave = true;
        },

        clearChanges() {
            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
            this.analyticType = '';

            if (this.isCreating) {
                let localJSON = MediatorIndicatorEditor.collected

                if (localJSON != null && localJSON != undefined && Object.keys(localJSON).length != 0 && Object.keys(localJSON).length > 1) {
                    this.createdReferences = localJSON.createdRefs;
                    this.equationList = localJSON.equation;

                    this.toSaveOnLocal = MediatorIndicatorEditor.collected;
                }
            } else {
                this.createdReferences = [...this.originalcreatedReferences];
                this.equationList = [...this.originalequationList];
            }

            this.addLabel = "Adicionar";
        },

        clearRefTabs() {
            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
            this.analyticType = '';
            this.addLabel = "Adicionar";
        },

        changeCollectorBase(base) {
            if ((base.toLowerCase().includes('automacao') || base.toLowerCase().includes('automação'))) {
                this.collectType = 'autom';
            } else if (base.toLowerCase().includes('analitico') || base.toLowerCase().includes('analítico') || base.toLowerCase().includes('sap') || base.toLowerCase().includes('pims') || base.toLowerCase().includes('gatec')) {
                this.collectType = 'analytic'

                if (base.toLowerCase().includes('com sufixo') || base.toLowerCase().includes('sufixo') || base.toLowerCase().includes('c/ sufixo') || base.toLowerCase().includes('com sufíxo') || base.toLowerCase().includes('c/ sufíxo') || base.toLowerCase().includes('c/sufixo') || base.toLowerCase().includes('c/sufíxo')) {
                    this.sufix = true
                } else {
                    this.sufix = false
                }
            }

            this.creatingReference.collectorBase = base;

        },

        handleOperation(opType, op) {
            if (opType != 'funcs') {
                this.addToEquation(op, 'operation');
                return;
            }

            this.modalOp = op;
            this.$bvModal.show('funcModal');

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        handleActive(newTabIndex) {
            if (newTabIndex == 0) {
                this.referenceType = "collector"
            } else if (newTabIndex == 1) {
                this.referenceType = "fixed"
            }
            else if (newTabIndex == 2) {
                this.referenceType = "indicator"
            }
        },

        clearEquation() {
            this.equationList = [];

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        undoEquation() {
            this.equationList.pop()

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        refDrag(evt, ref) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('draggedReference', JSON.stringify(ref));
        },

        refEnter(ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.add('overDrag');
        },

        refLeave(ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.remove('overDrag');
        },

        refDrop(evt, ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.remove('overDrag');

            let refMoved = evt.dataTransfer.getData('draggedReference');
            let refToAdd = JSON.parse(refMoved);

            if (!refToAdd.id || refToAdd.id == undefined) {
                this.equationList.splice(idx + 1, 0, { label: refToAdd.label, type: 'operation' });
            } else {
                this.equationList.splice(idx + 1, 0, { label: refToAdd.label, type: 'reference', structure: refToAdd });
            }

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        updateStorage() {
            this.toSaveOnLocal.createdRefs = this.createdReferences;
            this.toSaveOnLocal.equation = this.equationList;

            MediatorIndicatorEditor.collected = this.toSaveOnLocal;
        },

        async applyCollectedReferences() {
            let originalCompare = this.originalequationList.map(item => JSON.stringify(item)).join("");
            let currentCompare = this.equationList.map(item => JSON.stringify(item)).join("");

            if (this.equationList.length == 0 || (originalCompare == currentCompare && this.edited == false)) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Sem Modificações', 'Não existem modificações para salvar.');
                return;
            }

            if (this.validExp.status == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Expressão Inválida', 'A expressão criada não retornará valor, por favor verifique se está correta.');
                return;
            }

            this.isReloading = true;

            let sendToBack = {
                saveOnTree: {},
                saveOnCalculate: {},
                saveOnCollector: [],
            }

            MediatorIndicatorEditor.formatCollectedToReturn(this.equationList, sendToBack, this.selectedIndicator, this.createdReferences)


            await axios.post(`${urlMainAPI}/saveEditorIndicatorRealTag`, JSON.stringify({
                saveOnTree: sendToBack.saveOnTree,
                saveOnCalculate: sendToBack.saveOnCalculate,
                saveOnCollector: sendToBack.saveOnCollector
            }), {
                headers: { 'Content-Type': 'application/json' }
            }).then(async res => {
                if (res.status == 200) {
                    await this.$emit("reloadIndicator", this.selectedIndicator)
                    this.originalcreatedReferences = [...this.createdReferences];
                    this.originalequationList = [...this.equationList];
                    defaultSuccess('Valor Real atualizado com sucesso!')
                }
            }).catch(err => {
                console.error(err)
                showError('Falha ao salvar o valor real.')
            });

            this.isReloading = false;

        }
    },

    created() {
        this.operationsAllowed = MediatorIndicatorEditor.operationsAllowed;

        this.collectorBasesAllowed = MediatorIndicatorEditor.collectorsFound;
    },

    async mounted() {
        if (this.collectorBasesAllowed.length == 0 || MediatorIndicatorEditor.collectorsFound.length == 0) {
            await MediatorIndicatorEditor.getCollectorBases();
        }

        if (this.isCreating) {
            let localJSON = MediatorIndicatorEditor.collected

            if (localJSON != null && localJSON != undefined && Object.keys(localJSON).length != 0 && Object.keys(localJSON).length > 1) {
                this.createdReferences = localJSON.createdRefs;
                this.equationList = localJSON.equation;

                this.toSaveOnLocal = MediatorIndicatorEditor.collected;
            }
        }

        if (this.selectedIndicator.realRefs && this.selectedIndicator.realRefs.createdReferences && this.selectedIndicator.realRefs.equation) {
            if (this.createdReferences && this.createdReferences != undefined) {
                this.createdReferences = [...this.selectedIndicator.realRefs.createdReferences];
                this.originalcreatedReferences = [...this.createdReferences];
            }
            if (this.equationList && this.equationList != undefined) {
                this.equationList = [...this.selectedIndicator.realRefs.equation];
                this.originalequationList = [...this.equationList];
            }

            if (this.selectedIndicator.hasColError) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Coletor não Encontrado', 'Equação Real não encontrada nos Coletores SQL.');
            }

            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
            this.analyticType = '';
        }

        this.addLabel = "Adicionar";
    }
}
</script>
<style scoped>
@import '../commons/commonStyles.css';

.col-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 4.3rem;
    grid-auto-flow: row;
    column-gap: 0.5rem;
    overflow-y: auto;
    width: 100%;
    padding: 0.2rem 0.3rem;
    max-height: 20rem;
}

.cols-saturation {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cols-saturation span {
    margin-top: 0.8rem;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #FF5F00;
    text-align: center;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
}

.cols-saturation span::before {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

.cols-saturation span::after {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

.cols-saturation section {
    display: flex;
    column-gap: 0.8rem;
}

.overDrag::after {
    content: "";
    display: block;
    position: absolute;
    right: -6px;
    top: 0;
    width: 4px;
    height: 100%;
    border-radius: 0;
    background-color: #00A39F;
    border: none;
}

.tagListBtn {
    position: absolute;
    top: 3px;
    right: 0;
}

.tagListBtn p {
    padding: 0.2rem;
    border: 1px solid #FF5F00;
    color: #FF5F00;
    font-size: 0.8rem;
    font-weight: bold;
    border-radius: 0.2rem;
    cursor: pointer;
}

.tagListBtn p:hover {
    background-color: aliceblue;
}

.allow-tag-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: gray;
    padding: 0.5rem;
    color: white;
    font-weight: bolder;
}

.allow-tag-header p {
    margin: 0;
    padding: 0;
}

.allow-tag-list {
    max-height: 65vh;
    overflow-y: auto;
}

.allow-tag-list section {
    margin: 0;
    padding: 0.8rem 0.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid gray;
}

.allow-tag-list section:hover {
    background-color: #8d8d8d21;
}

.addIndBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;

    font-size: 0.8rem;
    font-weight: bold;
}

.addIndBtns section {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 0.3rem;
    border: 1px solid #fff;
    padding: 0.2rem;
    background-color: #00A39F;
    color: #fff;
    border-radius: 0.2rem;
    cursor: pointer;
}

.addPrev {
    background-color: #FF5F00 !important;
}

#filterAllowedTags {
    width: 100%;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    padding: 0.3rem;
    margin-bottom: 0.8rem;
}

.colTabledouble{
    color: gray;
    font-weight: 500;
    font-size: 0.9rem;
}

@media (max-height: 900px) {
    .col-inputs {
        max-height: 10rem;
    }
}
</style>